<template>
  <div>
    <div>
      <dashboard-fornecedor
        v-if="ehUsuarioFornecedor && canAccessDashFornecedor"/>
      <dashboard-funcionario-varejo
        v-else/>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex';
import { generateComputed } from '@/common/functions/roles-computed-generator';

import DashboardFuncionarioVarejo from '@/spa/dashboard/DashFuncionarioVarejo';
import DashboardFornecedor from '@/spa/dashboard/DashFornecedor';

export default {
  name: 'DashboardInicial',
  components: {
    DashboardFuncionarioVarejo,
    DashboardFornecedor,
  },
  computed: {
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    ...generateComputed('ACESSO_FORNECEDOR', [
      'getAllRoles',
    ]),
    canAccessDashFornecedor() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el.startsWith('ACESSO_FORNECEDOR')).length;
    },
    ehUsuarioFornecedor() {
      return this.usuarioLogado.tipo === 'FORNECEDOR';
    },
  },
};
</script>
